module.exports = __webpack_public_path__ + "static/MADE_Evolve_Sans_Bold-e4cc912b36f537f4859cf988cd77ad2a.woff";